(() => {
  const SUCCESS_PARAMETER = 'customer_posted';
  const SHOPIFY_EVENT_NAME = 'calinfi:complete_registration';
  const MAX_ATTEMPTS = 40;
  const RETRY_DELAY = 250;

  let dispatchStarted = false;
  let dispatchCompleted = false;

  const getSuccessUrl = () => {
    const url = new URL(window.location.href);
    return url.searchParams.get(SUCCESS_PARAMETER) === 'true' ? url : null;
  };

  const getSource = (url) => {
    if (url.searchParams.get('calinfi_email_popup') === 'subscribed') return 'popup_welcome10';
    if (url.searchParams.get('lead_submitted') === '1') return 'odun_launch_list';

    const hash = url.hash.toLowerCase();
    if (hash.includes('contactfooter')) return 'footer';
    if (hash.includes('calinfiheaderexploreform')) return 'header_explore';
    if (hash.includes('newsletter')) return 'newsletter';

    return 'storefront_newsletter';
  };

  const createEventId = () => {
    if (typeof window.crypto?.randomUUID === 'function') {
      return `calinfi-registration-${window.crypto.randomUUID()}`;
    }

    return `calinfi-registration-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
  };

  const clearSuccessParameter = (url) => {
    url.searchParams.delete(SUCCESS_PARAMETER);
    const nextUrl = `${url.pathname}${url.search}${url.hash}`;
    window.history.replaceState(window.history.state, '', nextUrl);
  };

  const completeDispatch = (url, eventId, source) => {
    dispatchCompleted = true;
    clearSuccessParameter(url);
    document.dispatchEvent(
      new CustomEvent('calinfi:complete-registration:sent', {
        detail: { eventId, source },
      })
    );
  };

  const publishRegistration = async (attempt = 0, eventId = createEventId()) => {
    if (dispatchCompleted) return true;

    const successUrl = getSuccessUrl();
    if (!successUrl) return false;

    if (dispatchStarted && attempt === 0) return false;
    dispatchStarted = true;

    const source = getSource(successUrl);
    const eventData = {
      eventId,
      contentName: 'CALINFI newsletter registration',
      contentCategory: 'Website subscription',
      source,
      status: 'completed',
    };

    if (typeof window.Shopify?.analytics?.publish === 'function') {
      try {
        const published = await window.Shopify.analytics.publish(SHOPIFY_EVENT_NAME, eventData);
        if (published) {
          completeDispatch(successUrl, eventId, source);
          return true;
        }
      } catch (_error) {}
    }

    if (typeof window.fbq === 'function') {
      window.fbq(
        'track',
        'CompleteRegistration',
        {
          content_name: eventData.contentName,
          content_category: eventData.contentCategory,
          status: eventData.status,
        },
        { eventID: eventId }
      );
      completeDispatch(successUrl, eventId, source);
      return true;
    }

    if (attempt < MAX_ATTEMPTS) {
      window.setTimeout(() => publishRegistration(attempt + 1, eventId), RETRY_DELAY);
      return false;
    }

    dispatchStarted = false;
    return false;
  };

  window.CalinfiCompleteRegistration = {
    publish: publishRegistration,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => publishRegistration(), { once: true });
  } else {
    publishRegistration();
  }

  document.addEventListener('visitorConsentCollected', () => {
    if (!dispatchCompleted) publishRegistration();
  });
})();
